import { recordActivation } from '@/features/onboarding/activation'
import type { WindowConfig } from './types'

const CHART_PANELS = new Set<string>(['chart', 'multi-chart'])

/**
 * Activation milestone `first_chart_opened_at`: the user deliberately put a ticker
 * on a chart. Called from the user-gesture symbol handlers (chart symbol search,
 * a scanner/watchlist/news/history click), never from seeding, layout restore or
 * preset apply, which write symbols without going through those handlers.
 */
export function recordChartOpenIfChartTickerChanged(
  prev: Record<string, WindowConfig>,
  next: Record<string, WindowConfig>,
): void {
  const changed = Object.entries(next).some(
    ([id, cfg]) => CHART_PANELS.has(cfg.componentType) && prev[id]?.symbolIndex !== cfg.symbolIndex,
  )
  if (changed) recordActivation('chart_opened')
}
